/*var images = document.querySelectorAll("img");
for (let i = 0; i < images.length; ++i) {
  var original_image_src = images[i].src;
  images[i].src = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII=";
  images[i].setAttribute('data-src', original_image_src);
  images[i].classList.add('lazy');
}
var _extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t},_typeof="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(t){return typeof t}:function(t){return t&&"function"==typeof Symbol&&t.constructor===Symbol&&t!==Symbol.prototype?"symbol":typeof t};!function(t,e){"object"===("undefined"==typeof exports?"undefined":_typeof(exports))&&"undefined"!=typeof module?module.exports=e():"function"==typeof define&&define.amd?define(e):t.LazyLoad=e()}(this,function(){"use strict";function t(t,e,n){var o=e._settings;!n&&i(t)||(C(o.callback_enter,t),R.indexOf(t.tagName)>-1&&(N(t,e),I(t,o.class_loading)),E(t,e),a(t),C(o.callback_set,t))}var e={elements_selector:"img",container:document,threshold:300,thresholds:null,data_src:"src",data_srcset:"srcset",data_sizes:"sizes",data_bg:"bg",class_loading:"loading",class_loaded:"loaded",class_error:"error",load_delay:0,callback_load:null,callback_error:null,callback_set:null,callback_enter:null,callback_finish:null,to_webp:!1},n=function(t){return _extends({},e,t)},o=function(t,e){return t.getAttribute("data-"+e)},r=function(t,e,n){var o="data-"+e;null!==n?t.setAttribute(o,n):t.removeAttribute(o)},a=function(t){return r(t,"was-processed","true")},i=function(t){return"true"===o(t,"was-processed")},s=function(t,e){return r(t,"ll-timeout",e)},c=function(t){return o(t,"ll-timeout")},l=function(t){return t.filter(function(t){return!i(t)})},u=function(t,e){return t.filter(function(t){return t!==e})},d=function(t,e){var n,o=new t(e);try{n=new CustomEvent("LazyLoad::Initialized",{detail:{instance:o}})}catch(t){(n=document.createEvent("CustomEvent")).initCustomEvent("LazyLoad::Initialized",!1,!1,{instance:o})}window.dispatchEvent(n)},f=function(t,e){return e?t.replace(/\.(jpe?g|png)/gi,".webp"):t},_="undefined"!=typeof window,v=_&&!("onscroll"in window)||/(gle|ing|ro)bot|crawl|spider/i.test(navigator.userAgent),g=_&&"IntersectionObserver"in window,h=_&&"classList"in document.createElement("p"),b=_&&function(){var t=document.createElement("canvas");return!(!t.getContext||!t.getContext("2d"))&&0===t.toDataURL("image/webp").indexOf("data:image/webp")}(),m=function(t,e,n,r){for(var a,i=0;a=t.children[i];i+=1)if("SOURCE"===a.tagName){var s=o(a,n);p(a,e,s,r)}},p=function(t,e,n,o){n&&t.setAttribute(e,f(n,o))},y=function(t,e){var n=b&&e.to_webp,r=o(t,e.data_src),a=o(t,e.data_bg);if(r){var i=f(r,n);t.style.backgroundImage='url("'+i+'")'}if(a){var s=f(a,n);t.style.backgroundImage=s}},w={IMG:function(t,e){var n=b&&e.to_webp,r=e.data_srcset,a=t.parentNode;a&&"PICTURE"===a.tagName&&m(a,"srcset",r,n);var i=o(t,e.data_sizes);p(t,"sizes",i);var s=o(t,r);p(t,"srcset",s,n);var c=o(t,e.data_src);p(t,"src",c,n)},IFRAME:function(t,e){var n=o(t,e.data_src);p(t,"src",n)},VIDEO:function(t,e){var n=e.data_src,r=o(t,n);m(t,"src",n),p(t,"src",r),t.load()}},E=function(t,e){var n=e._settings,o=t.tagName,r=w[o];if(r)return r(t,n),e._updateLoadingCount(1),void(e._elements=u(e._elements,t));y(t,n)},I=function(t,e){h?t.classList.add(e):t.className+=(t.className?" ":"")+e},L=function(t,e){h?t.classList.remove(e):t.className=t.className.replace(new RegExp("(^|\\s+)"+e+"(\\s+|$)")," ").replace(/^\s+/,"").replace(/\s+$/,"")},C=function(t,e){t&&t(e)},O=function(t,e,n){t.addEventListener(e,n)},k=function(t,e,n){t.removeEventListener(e,n)},x=function(t,e,n){O(t,"load",e),O(t,"loadeddata",e),O(t,"error",n)},A=function(t,e,n){k(t,"load",e),k(t,"loadeddata",e),k(t,"error",n)},z=function(t,e,n){var o=n._settings,r=e?o.class_loaded:o.class_error,a=e?o.callback_load:o.callback_error,i=t.target;L(i,o.class_loading),I(i,r),C(a,i),n._updateLoadingCount(-1)},N=function(t,e){var n=function n(r){z(r,!0,e),A(t,n,o)},o=function o(r){z(r,!1,e),A(t,n,o)};x(t,n,o)},R=["IMG","IFRAME","VIDEO"],S=function(e,n,o){t(e,o),n.unobserve(e)},M=function(t){var e=c(t);e&&(clearTimeout(e),s(t,null))},j=function(t,e,n){var o=n._settings.load_delay,r=c(t);r||(r=setTimeout(function(){S(t,e,n),M(t)},o),s(t,r))},D=function(t){return t.isIntersecting||t.intersectionRatio>0},T=function(t){return{root:t.container===document?null:t.container,rootMargin:t.thresholds||t.threshold+"px"}},U=function(t,e){this._settings=n(t),this._setObserver(),this._loadingCount=0,this.update(e)};return U.prototype={_manageIntersection:function(t){var e=this._observer,n=this._settings.load_delay,o=t.target;n?D(t)?j(o,e,this):M(o):D(t)&&S(o,e,this)},_onIntersection:function(t){t.forEach(this._manageIntersection.bind(this))},_setObserver:function(){g&&(this._observer=new IntersectionObserver(this._onIntersection.bind(this),T(this._settings)))},_updateLoadingCount:function(t){this._loadingCount+=t,0===this._elements.length&&0===this._loadingCount&&C(this._settings.callback_finish)},update:function(t){var e=this,n=this._settings,o=t||n.container.querySelectorAll(n.elements_selector);this._elements=l(Array.prototype.slice.call(o)),!v&&this._observer?this._elements.forEach(function(t){e._observer.observe(t)}):this.loadAll()},destroy:function(){var t=this;this._observer&&(this._elements.forEach(function(e){t._observer.unobserve(e)}),this._observer=null),this._elements=null,this._settings=null},load:function(e,n){t(e,this,n)},loadAll:function(){var t=this;this._elements.forEach(function(e){t.load(e)})}},_&&function(t,e){if(e)if(e.length)for(var n,o=0;n=e[o];o+=1)d(t,n);else d(t,e)}(U,window.lazyLoadOptions),U});
var myLazyLoad = new LazyLoad({
  elements_selector: ".lazy"
});*/

$(function(){
  $(document).ready(function () { iframeresize(); });
  $(window).resize(function () { iframeresize(); });

  function iframeresize(){
    $("iframe").each(function() {
      var width = $(this).width ();
      $(this).css("height", width / 1.4 + "px");
    });
  }
});

$(document).ready(function () {
  $(".show-all").click(function (e) {
    e.preventDefault();
    $(".hidden-slot").css('display', 'block');
    $(".has-btn").css('display', 'none');
  });
  $('#showMenu').click(function () {
    $(this).toggleClass('open');
    $('.h-item-menu').animate({'width': 'toggle'}, 100);
  });
  $('#close-menu').click(function () {
    $('#showMenu').toggleClass('open');
    $('.h-item-menu').animate({'width': 'toggle'}, 100);
  });
  $('nav.header-menu ul li a').click(function () {
    if ($('#close-menu').css('display') == 'block') {
      $('#showMenu').toggleClass('open');
      $('.h-item-menu').animate({'width': 'toggle'}, 100);
    }
  });
  $('.slider-wrap').slick({
    dots: true,
    arrows: false,
    autoplay: true,
    infinite: true,
    appendDots: $('.slider-nav'),
  });

  // slots wins slider
  $('.slots-slider__wrap').slick({
    dots: false,
    arrows: false,
    autoplay: true,
    infinite: false,
    slidesToShow: 3,
    slidesToScroll: 1,
    vertical: false,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 600,
        settings: {
          vertical: true,
          verticalSwiping: true,
          slidesToShow: 3,
        }
      }
    ]
  });
});

var activeClass = 'active',
  ariaAttribute = 'aria-hidden';
$('.slider-wrap')
  .on( 'init', function() {
    $( '.slider-wrap .slick-dots li:first-of-type' ).addClass( activeClass ).attr( ariaAttribute, false );
  } )
  .on( 'afterChange', function( event, slick, currentSlide ) {
    var $dots = $( '.slick-dots' );
    $( 'li', $dots ).removeClass( activeClass ).attr( ariaAttribute, true );
    $dots.each( function() {
      $( 'li', $( this ) ).eq( currentSlide ).addClass( activeClass ).attr( ariaAttribute, false );
    } );
  } );

document.addEventListener("DOMContentLoaded", readyHTML);
function readyHTML() {
  jekpot_count('.jek-pot-count');

}
function jekpot_count(container) {
  var curent_container = document.querySelector(container);
  if (curent_container) {
    _winjacpot(curent_container);
  }
  function _winjacpot(el) {
    var default_val = 1000000, //стартовое значение, которое увидит пользователь при первой загрузке страницы
      minimum_val = 1000000, //к этому значению будет сброшено число, когда перевалит максимальное значение
      maximum_val = 2000000, //максимальное значение числа
      current = 0, //тут будет хранится текущее значение числа
      min = 0, //минимальное приращениеk
      max = 1, //максимальное приращение
      min_time = 3000, //мин.временной интервал обновления
      max_time = 6000, //макс.временной интервал обновления
      timer = '', //здесь будет хранится рекурсивный вызов таймера
      time = '', //а здесь - случайный временной интервал
      method = {}; //методы (функции)
    type = 'jekpot';
    method.init = function () {
      //получим значение числа из localStorage
      current = parseFloat(localStorage.getItem('winValue'+type)); //сразу преобразуем в число
      if (!current) {//если его там нет - установим дефолтное
        method.save(default_val);
      }
      method.show(current); //отобразим на странице

      //рекурсивный setTimeot, в который передадим случайный временной интервал time
      time = method.getRandomTime();
      timer = setTimeout(function tick() {
        method.add();//увеличили значение числа на случайную величину и отобразили на странице
        time = method.getRandomTime();
        timer = setTimeout(tick, time);
      }, time);
    };

    method.save = function (val) {//запишем текущее значение в localStorage
      try {
        saveToStorage();
      } catch (e) {
        if (e == QUOTA_EXCEEDED_ERR) {//если оно переполнено - очистим и запишем повторно
          localStorage.clear();
          saveToStorage();
        }
      }
      function saveToStorage() {
        localStorage.setItem('winValue'+type, val);
        current = val;
      }
    };

    method.show = function (val) { //отобразим текущее значение на странице, предварительно преобразовав число в нужный формат
      var num_array = String(val).split('');
      var data_num = el.querySelectorAll('span');
      if (data_num) {
        for (var j = 0; j < data_num.length; j++) {
          if (num_array[j]) {
            data_num[j].setAttribute('data-number',num_array[j]);
            data_num[j].innerHTML = num_array[j];
          } else {
            data_num[j].remove();
          }
        }
      } else {
        for (var i = 0; i < num_array.length; i++) {
          if (i == 0 ) {
            el.innerHTML += '<span data-number="'+num_array[i]+'">'+num_array[i]+'</span>';

            el.innerHTML += '<div class="currency">&#8381;</div>';
          } else {
            el.innerHTML += '<span data-number="'+num_array[i]+'"></span>';
          }
          if ( i == (num_array.length-1)) {
            el.innerHTML += '<span class="currency"></span>';
          }
        }
      }
    };
    method.add = function () {//увеличим значение числа на случайную величину
      // будем брать значение из localStorage а не из переменной, т.к. страница может быть открыта в двух вкладках (например) и это позволит частично их синхронизировать
      current = parseFloat(localStorage.getItem('winValue'+type)) + Math.round((Math.random() * (max - min) + min) * 100); //увеличим на случайное число, округленное до целого
      if (current > maximum_val) {//если перевалили за максимум - сбросим к минимуму
        current = minimum_val;
      }
      method.save(current); //сохранили в localStorage
      method.show(current); //вывели на экран
    };
    method.getRandomTime = function () {//вернем случайный целый интервал от 200 до 8000 милисекунд
      return Math.floor(Math.random() * (max_time - min_time + 1)) + min_time;
    };
    method.init();
  }
}


document.addEventListener("DOMContentLoaded", function (event) {
  window.onscroll = function () {
    fixedIsActive()
  };
  var toTopButton = document.getElementById("toTop");

  function fixedIsActive() {
    if (window.pageYOffset > 50) {
      toTopButton.classList.add("fixed");
    } else {
      toTopButton.classList.remove("fixed");
    }
  }

  toTopButton.onclick = scrollToTop;

  function scrollToTop() {
    window.scrollTo({top: 0, behavior: 'smooth'});
  }
});